import React, { useCallback } from 'react';
import PropTypes from 'prop-types';

import config from '../../config';

import AdminImportPage from '../shared/adminImportPage.component';
import { adminPageNames, adminPageTitles } from '../shared/adminPageNames';

import AddEditModal from './addEditModal.component';
import DeleteModal from './deleteModal.component';
import downloadXlsxFile from './downloadSlAccountsXlsx';

import {
  sharedActions,
} from './store/actions';

import { withPermissions, permissions } from '../../shared/authorization';
import columnDefinitions from '../../shared/columnDefinitions/slAccountsPage';
import AdminColumnRenderer from '../../administration/slAccountsPage/adminColumnRenderer.component';

const SlAccountsPage = ({
  canModifyInSelectedPeriod,
}) => {
  const generateTemplateFileName = useCallback(
    ({ periodName }) => `TLS_Balance_Sheet_Management_Account_${periodName}`,
    []
  );

  const idFieldComparator = useCallback((slAccount, importedSlAccount) =>
    `${slAccount.periodName}${slAccount.slAccount}` === `${importedSlAccount.periodName}${importedSlAccount.slAccount}`
  , []);

  return (
    <AdminImportPage
      pageName={adminPageNames.SL_ACCOUNTS}
      canModify={canModifyInSelectedPeriod}
      AddEditEntityModal={AddEditModal}
      RemoveEntityModal={DeleteModal}
      adminColumnRenderer={AdminColumnRenderer}
      addEntityMessage="Add Account"
      columnDefs={columnDefinitions}
      actions={sharedActions}
      exportToExcel={downloadXlsxFile}
      generateTemplateFileName={generateTemplateFileName}
      templatePath={config.templates.SL_ACCOUNTS}
      comparatorConfig={{
        idField: 'slAccount',
        idFieldComparator,
      }}
      pageTitle={adminPageTitles.SL_ACCOUNTS}
    />
  );
};

SlAccountsPage.propTypes = {
  canModifyInSelectedPeriod: PropTypes.bool.isRequired,
};

export default withPermissions(permissions.CORRECTING_ENTRY_LIST_PAGE)(SlAccountsPage);
